import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { SFSchema, SFUISchema, SFRadioWidgetSchema, SFSelectWidgetSchema, SFDateWidgetSchema } from '@delon/form';
import { of, Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { promise } from 'protractor';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';

@Component({
  selector: 'header-danwei',
  templateUrl: './header-danwei.component.html',
})
export class HeaderDanweiComponent implements OnInit {
  isAdd = false;
  record: any = {};
  i: any;

  schema: SFSchema = {
    properties: {
      tenant_name: { type: 'string', title: '单位名称', minLength: 2, maxLength: 15 },
    },
    required: ['tenant_name'],
  };
  ui: SFUISchema = {
    '*': {
      spanLabelFixed: 100,
      grid: { span: 12 },
    },
  };

  constructor(
    private modal: NzModalRef,
    private msgSrv: NzMessageService,
    public http: _HttpClient,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
  ) {}

  ngOnInit(): void {
    this.http.post(`api/user/getdanwei`).subscribe(res => (this.i = res));
  }

  save(value: any) {
    this.http.post(`api/user/updatedanwei`, value).subscribe(res => {
      if (res.code == '000') {
        this.msgSrv.success('更新成功');
      } else {
        this.msgSrv.error('更新失败');
      }
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
